import fetch from 'isomorphic-fetch';
import Config from '../../config/';
import language from '../../../components/locales';
import FormData from 'form-data';
import { detect } from 'detect-browser';
const browser = detect();

const API = {
  data: {
    async getAll(obj) {
      let response = await fetch(
        `${Config.api}/api/tasksmanager/${encodeURIComponent(JSON.stringify(obj))}`,
        {
          method: 'GET',
          headers: new Headers({
            Pragma: 'no-cache'
          })
        }
      );

      const status = response.status;
      let data = await response.json();
      return {
        data: data.response,
        status: status
      };
    },
    async getCount(obj) {
      let response = await fetch(
        `${Config.api}/api/tasksmanagerCount/${encodeURIComponent(JSON.stringify(obj))}`,
        {
          method: 'GET',
          headers: new Headers({
            Pragma: 'no-cache'
          })
        }
      );

      const status = response.status;
      let data = await response.json();
      return {
        data: data.response,
        status
      };
    },
    async handleDownloadSummaryReport(obj) {
      let response = await fetch(`${Config.api}/api/tasksmanagerdownloadsummaryexcel/${encodeURIComponent(JSON.stringify(obj))}`, {
        method: 'GET',
        'Content-Type': 'blob',
        headers: new Headers({ Pragma: 'no-cache' })
      });
      const status = response.status;
      const statusText = response.statusText;

      if(status==200) {
        const blob = await response.blob();
        var a = document.createElement('a');
        var today = new Date();
        var todayString = today.toISOString().slice(0, 10);
        var filename = `${language.tasks_manager.excel.downloadFileNameSummary}_${todayString}.xlsx`;

        if (browser.name == 'ie') {
          window.navigator.msSaveBlob(blob, filename);
        } else {
          a.setAttribute('href', window.URL.createObjectURL(blob));
          a.setAttribute('target', '_blank');
          a.setAttribute('download', filename);
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }
    
      return {
        data: statusText,
        status: status
      };
    },
    async handleDownloadNoProcessReport(obj) {
      let response = await fetch(`${Config.api}/api/tasksmanagerdownloadnoprocessexcel/${encodeURIComponent(JSON.stringify(obj))}`, {
        method: 'GET',
        'Content-Type': 'blob',
        headers: new Headers({ Pragma: 'no-cache' })
      });
      const status = response.status;
      const statusText = response.statusText;

      if(status==200) {
        const blob = await response.blob();
        var a = document.createElement('a');
        var today = new Date();
        var todayString = today.toISOString().slice(0, 10);
        var filename = `${language.tasks_manager.excel.downloadFileNameNoProcess}_${todayString}.xlsx`;

        if (browser.name == 'ie') {
          window.navigator.msSaveBlob(blob, filename);
        } else {
          a.setAttribute('href', window.URL.createObjectURL(blob));
          a.setAttribute('target', '_blank');
          a.setAttribute('download', filename);
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }

      return {
        data: statusText,
        status: status
      };
    },
    async getTask(obj) {
      let response = await fetch(
        `${Config.api}/api/tasksmanagertask/${encodeURIComponent(JSON.stringify(obj))}`,
        {
          method: 'GET',
          headers: new Headers({
            Pragma: 'no-cache'
          })
        }
      );

      const status = response.status;
      let data = await response.json();

      return {
        data: data.response,
        status: status
      };
    },
    async getFieldEnpointData(obj) {
      let response = await fetch(
        `${Config.api}/api/tasksmanagergetfieldendpointdata/${encodeURIComponent(JSON.stringify(obj))}`,
        {
          method: 'GET',
          headers: new Headers({
            Pragma: 'no-cache'
          })
        }
      );

      const status = response.status;
      let data = await response.json();
      return {
        data: data.response,
        status: status
      };
    },
    async annulTasks(ids) {
      const response = await fetch(`/api/tasksmanagerannul`, {
        method: 'DELETE',
        headers: new Headers({
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Pragma: 'no-cache'
        }),
        body: JSON.stringify(ids)
      });
      const status = response.status;
      const data = await response.json();
      return { data: data, status: status };
    },
    async saveTask(id,taskData,files) {
      var formData = new FormData();
      formData.append('incidentDetail', JSON.stringify(taskData));
      for (var i = 0; i < files.length; i++) {
        formData.append('file'+i, files[i]);
      }
      let response = await fetch(`${Config.api}/api/tasksmanagersave/${id}`, {
        body: formData,
        method: 'POST',
        headers: new Headers({ Pragma: 'no-cache' })
      });
      const status = response.status;
      const data = await response.json();
      return { data: data, status: status };
    },
    async getTaskFile(obj) {
      let response = await fetch(`${Config.api}/api/tasksmanagergettaskfile/${encodeURIComponent(JSON.stringify(obj))}`, {
        method: 'GET',
        'Content-Type': 'blob',
        headers: new Headers({ Pragma: 'no-cache' })
      });
      const status = response.status;       

      if(status==200) {
        var nameFile = obj.filename;    
        const blob = await response.blob();
        var a = document.createElement('a');
        if (browser.name == 'ie') {
          window.navigator.msSaveBlob(blob, nameFile);
        } else {
          a.setAttribute('href', window.URL.createObjectURL(blob));
          a.setAttribute('target', '_blank');
          a.setAttribute('download', nameFile);
          a.style.display = 'none';
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        }
      }

      return {
        data: 'ok',
        status: status
      };
    },
    async getFilters() {
      let response = await fetch(
        `${Config.api}/api/tasksmanagergetfilters`,
        {
          method: 'GET',
          headers: new Headers({
            Pragma: 'no-cache'
          })
        }
      );

      const status = response.status;
      let data = await response.json();
      return {
        data: data.response,
        status: status
      };
    },
  },
};
export default API;



// WEBPACK FOOTER //
// ./source/client/actions/tasks_manager/api/index.js